export default __webpack_public_path__ + "static/media/arrow-top.97b36ac3.svg";